import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { environment } from '../../environments/environment';
import { AppActions } from './app.actions';

export const appFeatureKey = 'app';

export interface AppState {
  uiReleaseVersion: string;
  apiReleaseVersion: string | undefined;
}

const initialAppState: AppState = {
  uiReleaseVersion: environment.appReleaseVersion,
  apiReleaseVersion: undefined,
};

export const appFeature = createFeature({
  name: appFeatureKey,
  reducer: createReducer(
    initialAppState,
    on(AppActions.setApiReleaseVersion, (state, { apiReleaseVersion }) => ({
      ...state,
      apiReleaseVersion,
    })),
  ),
  extraSelectors: ({ selectUiReleaseVersion, selectApiReleaseVersion }) => ({
    isApiReleaseVersionDifferentThanUiReleaseVersion: createSelector(
      selectUiReleaseVersion,
      selectApiReleaseVersion,
      (uiReleaseVersion, apiReleaseVersion) =>
        apiReleaseVersion ? apiReleaseVersion !== uiReleaseVersion : false,
    ),
    selectUiReleaseVersionWithoutPrefix: createSelector(
      selectUiReleaseVersion,
      (uiReleaseVersion) => uiReleaseVersion?.replace(/^v/, ''),
    ),
    selectApiReleaseVersionWithoutPrefix: createSelector(
      selectApiReleaseVersion,
      (apiReleaseVersion) => apiReleaseVersion?.replace(/^v/, ''),
    ),
  }),
});
